import React, { useState, useEffect, useCallback, useContext, useRef } from "react";
import Header from "../components/Header";
import "../assets/CSS/Dashboard.css";
import axiosInstance from "../axiosConfig";
import { AuthContext } from "../AuthContext";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import "./Tickets.css"; // Premium UI Styles
import Swal from "sweetalert2";
import { PhotoCell, Lightbox } from "../components/PhotoViewer";

function TicketHome() {
  const { user } = useContext(AuthContext); // Get logged-in user data
  const [tickets, setTickets] = useState([]); // All tickets
  const [filteredTickets, setFilteredTickets] = useState([]); // Filtered tickets
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showModal, setShowModal] = useState(false); // Modal state
  const [submitting, setSubmitting] = useState(false);
  const [lightbox, setLightbox] = useState(null);
  const [formData, setFormData] = useState({
    Category: "",
    Subject: "",
    Brief_Description: "",
    Supervisor_Name: user?.Name || "", // Pre-fill Supervisor Name from user context
    Priority: "",
    Responsible: "", // New field
    DueDate: "", // New field
    photo: null,
  });
  const [filters, setFilters] = useState({
    searchQuery: "",
    fromDate: "",
    toDate: "",
    category: "",
  });

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  // Memoize the fetchTickets function
  // const fetchTickets = useCallback(async () => {
  //   try {
  //     const response = await axiosInstance.get("/api/tickets", {
  //       params: { EmployeeID: user?.EmployeeID }, // Pass EmployeeID as query parameter
  //     });
  //     setTickets(response.data);
  //     setFilteredTickets(response.data); // Initialize filtered tickets
  //   } catch (error) {
  //     console.error("Error fetching tickets:", error);
  //     alert("Failed to fetch tickets.");
  //   }
  // }, [user?.EmployeeID]);

  // useEffect(() => {
  //   fetchTickets();
  // }, [fetchTickets]); // Fetch tickets when user data changes or fetchTickets changes

  const [loading, setLoading] = useState(false);

  const isFetching = useRef(false);

  const fetchTickets = useCallback(async () => {
    if (!user?.EmployeeID || isFetching.current) return;

    isFetching.current = true;

    try {
      const response = await axiosInstance.get("/api/tickets", {
        params: { EmployeeID: user.EmployeeID },
        timeout: 10000,
      });

      setTickets(response.data);
      setFilteredTickets(response.data);
    } catch (error) {
      console.error("Error fetching tickets:", error);
    } finally {
      isFetching.current = false;
    }
  }, [user?.EmployeeID]);

  // 1. Page load pe turant data lao
  useEffect(() => {
    fetchTickets();
  }, [fetchTickets]);

  // 2. Auto refresh (2 min)
  useEffect(() => {
    const interval = setInterval(() => {
      if (document.visibilityState === "visible") {
        fetchTickets();
      }
    }, 120000);

    return () => clearInterval(interval);
  }, [fetchTickets]);

  // Handle Input Changes for Filters
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Memoize applyFilters to prevent recreation on every render
  const applyFilters = useCallback(() => {
    const { searchQuery, fromDate, toDate, category } = filters;

    const filtered = tickets.filter((ticket) => {
      //const ticketDate = new Date(ticket.RaiseDate);
      const ticketDate = ticket.RaiseDate ? new Date(ticket.RaiseDate) : null;

      const matchesSearch =
        searchQuery === "" ||
        [
          ticket.ID,
          ticket.Category,
          ticket.Subject,
          ticket.Brief_Description,
          ticket.Supervisor_Name,
          ticket.Priority,
          ticket.Responsible,
          ticket.Status,
        ]
          .join(" ")
          .toLowerCase()
          .includes(searchQuery.toLowerCase());

      // const matchesDate =
      //   (fromDate === "" || ticketDate >= new Date(fromDate)) &&
      //   (toDate === "" || ticketDate <= new Date(toDate));

      const matchesDate =
        (!fromDate || (ticketDate && ticketDate >= new Date(fromDate))) &&
        (!toDate || (ticketDate && ticketDate <= new Date(toDate)));

      const matchesCategory =
        category === "" || ticket.Category === category;

      return matchesSearch && matchesDate && matchesCategory;
    });

    // Sort by descending order (newest first)
    filtered.sort((a, b) => b.ID - a.ID);

    setFilteredTickets(filtered);
  }, [filters, tickets]);

  useEffect(() => {
    applyFilters();
  }, [filters, applyFilters]);

  // Handle Input Changes for Modal Form
  const handleFormChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "photo") {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  // Submit New Ticket
  // const handleFormSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     const requestData = {
  //       ...formData,
  //       EmployeeID: user?.EmployeeID, // Add EmployeeID dynamically
  //     };
  //     await axiosInstance.post("/api/tickets", requestData);
  //     alert("Ticket created successfully!");
  //     setShowModal(false);
  //     fetchTickets(); // Refresh tickets after creation
  //     setFormData({
  //       Category: "",
  //       Subject: "",
  //       Brief_Description: "",
  //       Supervisor_Name: user?.Name || "", // Reset Supervisor Name
  //       Priority: "",
  //       Responsible: "",
  //       DueDate: "",
  //     });
  //   } catch (error) {
  //     console.error("Error creating ticket:", error);
  //     alert("Failed to create ticket.");
  //   }
  // };
 
  const isCreating = useRef(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    //if (submitting) return; // prevent multiple clicks
    if (isCreating.current) return; // stronger lock
    isCreating.current = true;

    setSubmitting(true);

    try {
      if (!formData.DueDate) {
        Swal.fire("Error", "Due Date is required", "error");
        return;
      }

      const requestData = new FormData();
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null && formData[key] !== "") {
          requestData.append(key, formData[key]);
        }
      });
      requestData.append("EmployeeID", user?.EmployeeID);

      await axiosInstance.post("/api/tickets", requestData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      // Success alert
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Ticket created successfully!",
        timer: 2000,
        showConfirmButton: false,
      });

      setShowModal(false);
      fetchTickets();

      setFormData({
        Category: "",
        Subject: "",
        Brief_Description: "",
        Supervisor_Name: user?.Name || "",
        Priority: "",
        Responsible: "",
        DueDate: "",
        photo: null,
      });

    } catch (error) {
      console.error("Error creating ticket:", error);

      // Error alert
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to create ticket! try again after page refresh",
      });

    } finally {
      setSubmitting(false); // ✅ reset button
      isCreating.current = false;
    }
  };

// Function to confirm ticket deletion
const confirmTicket = async (id) => {
  const result = await Swal.fire({
    title: 'Are you sure?',
    text: "You want to approve and close this ticket!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes, Approve it!'
  });

  if (!result.isConfirmed) return;

  try {
    await axiosInstance.post(`/api/tickets/confirm/${id}`);
    Swal.fire({
      title: 'Approved!',
      text: 'Ticket confirmed and moved to solved tickets.',
      icon: 'success',
      timer: 2000,
      showConfirmButton: false
    });
    fetchTickets(); // Refresh the tickets after confirmation
  } catch (error) {
    console.error("Error confirming ticket:", error);
    Swal.fire('Error!', 'Failed to confirm ticket.', 'error');
  }
};

// Function to reject a ticket // 20 march 25
const rejectTicket = async (id) => {
  const result = await Swal.fire({
    title: 'Reject Ticket?',
    text: "Are you sure you want to reject this ticket?",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#dc3545',
    cancelButtonColor: '#6c757d',
    confirmButtonText: 'Yes, Reject it!'
  });

  if (!result.isConfirmed) return;

  try {
    await axiosInstance.patch(`/api/tickets/reject/${id}`);
    Swal.fire({
      title: 'Rejected!',
      text: 'Ticket rejected successfully.',
      icon: 'success',
      timer: 2000,
      showConfirmButton: false
    });
    fetchTickets(); // Refresh tickets after rejection
  } catch (error) {
    console.error("Error rejecting ticket:", error);
    Swal.fire('Error!', 'Failed to reject ticket.', 'error');
  }
};



  return (
    <div className="d-flex dashboard">
      <Lightbox src={lightbox} onClose={() => setLightbox(null)} />
      <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1 tickets-dashboard-container">
      <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{height:"-webkit-fill-available"}}>
          <div className="container mt-0">
            {/* Header & Button */}
            <div className="d-flex justify-content-between align-items-center mb-4 mt-2">
              <h4 className="fw-bold text-secondary mb-0" style={{ letterSpacing: "0.5px" }}><i className="bi bi-ticket-detailed me-2 text-primary"></i>Tickets Dashboard</h4>
              <button
                className="btn btn-premium"
                onClick={() => setShowModal(true)}
              >
                <i className="bi bi-plus-circle-fill me-2"></i>Raise a Ticket
              </button>
            </div>

            {/* Filter Section */}
            <div className="card glass-card p-4 mb-4">
              <div className="row g-3 align-items-center">
                <div className="col-md-2">
                  <select
                    name="category"
                    value={filters.category}
                    onChange={handleFilterChange}
                    className="form-select modern-input"
                  >
                    <option value="">All Categories</option>
                    {[...new Set(tickets.map(t => t.Category).filter(Boolean))].map((cat, idx) => (
                      <option key={idx} value={cat}>{cat}</option>
                    ))}
                  </select>
                </div>
                <div className="col-md-3">
                  <input
                    type="text"
                    name="searchQuery"
                    value={filters.searchQuery}
                    onChange={handleFilterChange}
                    className="form-control modern-input"
                    placeholder="Search tickets..."
                  />
                </div>
                <div className="col-md-2">
                  <input
                    type="date"
                    name="fromDate"
                    value={filters.fromDate}
                    onChange={handleFilterChange}
                    className="form-control modern-input"
                    title="From Date"
                  />
                </div>
                <div className="col-md-2">
                  <input
                    type="date"
                    name="toDate"
                    value={filters.toDate}
                    onChange={handleFilterChange}
                    className="form-control modern-input"
                    title="To Date"
                  />
                </div>
                <div className="col-md-auto ms-auto">
                  <button
                    className="btn btn-outline-danger shadow-sm fw-semibold"
                    onClick={() =>
                      setFilters({
                        searchQuery: "",
                        fromDate: "",
                        toDate: "",
                        category: "",
                      })
                    }
                  >
                    <i className="bi bi-arrow-counterclockwise me-1"></i>Reset
                  </button>
                </div>
              </div>
            </div>

            {/* Tickets Table */}
            <div className="modern-table-container">
              <table className="table modern-table table-borderless">
                <thead>
                  <tr>
                    <th>Ticket Number</th>
                    <th>Lot ID</th>
                    <th>Category</th>
                    <th>Responsible</th>
                    <th>Subject</th>
                    <th>Brief Description</th>
                    <th>Photo</th>
                    <th>Supervisor Name</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Raise Date</th>
                    <th>Due Date</th>
                    <th>Remark</th>
                    <th>Approve Status</th>
                   
                  </tr>
                </thead>
                <tbody>
                  {filteredTickets.length > 0 ? (
                    filteredTickets.map((ticket) => (
                      <tr key={ticket.ID}>
                        <td>{ticket.ID}</td>
                        <td>{ticket.lot_id || "-"}</td>
                        <td>{ticket.Category}</td>
                        <td>{ticket.Responsible}</td>
                        <td>{ticket.Subject}</td>
                        <td>{ticket.Brief_Description}</td>
                        <td><PhotoCell src={ticket.photo_path} label="Ticket Photo" onView={setLightbox} /></td>
                        <td>{ticket.Supervisor_Name}</td>
                        <td>{ticket.Priority}</td>
                        <td>
                          <span className={`status-badge ${
                            ticket.Status === 'Resolved' ? 'status-resolved' :
                            ticket.Status === 'Pending' ? 'status-pending' : 'status-open'
                          }`}>
                            {ticket.Status}
                          </span>
                        </td>
                        <td>{ticket.RaiseDate}</td>
                        <td>{ticket.DueDate}</td>
                        <td>{ticket.Remarks}</td>
                        <td >
                        {ticket.Status === "Resolved" && (
                          <div className="d-flex gap-2 justify-content-center">
                            <button
                              className="btn btn-success btn-sm rounded-pill shadow-sm px-3"
                              onClick={() => confirmTicket(ticket.ID)}
                              title="Approve Ticket"
                            >
                               <i className="bi bi-check-circle-fill me-1"></i>Approve
                            </button>
                            <button
                               className="btn btn-danger btn-sm rounded-pill shadow-sm px-3"
                               onClick={() => rejectTicket(ticket.ID)}
                               title="Reject Ticket"
                            >
                               <i className="bi bi-x-circle-fill me-1"></i>Reject
                            </button>
                          </div>
                        )}
                      </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="12" className="text-center">
                        No Tickets Available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>

      {/* Raise Ticket Modal */}
      {showModal && (
        <div className="modal show fade d-block premium-modal" tabIndex="-1" style={{ background: "rgba(0,0,0,0.4)", backdropFilter: "blur(5px)" }}>
          <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header text-white">
                <h5 className="modal-title fw-bold"><i className="bi bi-ticket-perforated-fill me-2"></i>Raise a New Ticket</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white shadow-none"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <form onSubmit={handleFormSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Category</label>
                      <input
                        type="text"
                        name="Category"
                        value={formData.Category}
                        onChange={handleFormChange}
                        className="form-control"
                        placeholder="Enter Category"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Responsible</label>
                      <select
                        name="Responsible"
                        value={formData.Responsible}
                        onChange={handleFormChange}
                        className="form-select"
                        required
                      >
                        <option value="">Select Responsible Person</option>
                        <option value="Sandeep Thakur">Sandeep Thakur</option>
                        <option value="Asif Khan">Asif Khan </option>
                        <option value="imtiyaz husen shah">Imtiyaz husen</option>                     
                        <option value="Ali">Ali</option>
                        <option value="Birbahadur Kumar Lalmuniram">Birbahadur Kumar Lalmuniram</option> 
                        <option value="Panchram Varma">Panchram Varma</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Subject</label>
                      <input
                        type="text"
                        name="Subject"
                        value={formData.Subject}
                        onChange={handleFormChange}
                        className="form-control"
                        placeholder="Enter Subject"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Priority</label>
                      <select
                        name="Priority"
                        value={formData.Priority}
                        onChange={handleFormChange}
                        className="form-select"
                        required
                      >
                        <option value="">Select Priority</option>
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                      </select>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Due Date</label>
                      <input
                        type="datetime-local"
                        name="DueDate"
                        value={formData.DueDate}
                        onChange={handleFormChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Photo (Optional)</label>
                      <input
                        type="file"
                        name="photo"
                        accept="image/*"
                        onChange={handleFormChange}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Brief Description</label>
                    <textarea
                      name="Brief_Description"
                      value={formData.Brief_Description}
                      onChange={handleFormChange}
                      className="form-control"
                      placeholder="Enter Brief Description"
                      rows="3"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer border-0 bg-light">
                  <button
                    type="button"
                    className="btn btn-outline-secondary fw-semibold px-4 rounded-pill"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-premium" disabled={submitting}>
                    {submitting ? (
                      <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Submitting...</>
                    ) : (
                      <><i className="bi bi-send-fill me-2"></i>Submit Ticket</>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TicketHome;
